module.exports = __webpack_public_path__ + "static/media/ic_config_arrow.c6e078bd.jpg";